export default {
    open(){
        window.open('https://homefit.channel.io', '_blank')
    }
}